import isEmpty from 'lodash-es/isEmpty';
import isNil from 'lodash-es/isNil';

/**
 * Recursively checks whether a value is filled in (non-nil, non-empty).
 *
 * @param item - The value to check.
 * @returns True if the value is considered filled in, otherwise false.
 */
export const isFilledIn = (item: unknown): boolean => {
  if (isNil(item)) return false;

  if (item && typeof item === 'object')
    return Object.values(item).some((value) => isFilledIn(value));

  if (['number', 'boolean'].includes(typeof item)) return !isNil(item);

  return !isEmpty(item);
};
